import cContactForm from '../components/c-contact-form';

export default function () {
  cContactForm();
}
